export const ORGANIZATION_USER_DETAIL_ACCESS = {
  ADMIN: 0,
  STANDARD: 1,
  EXTERNAL: 2,
} as const;
